//import { writable, type Writable } from "svelte/store"
import { xhr, toast } from "$app/utils"

export async function loadFiles(
  plan_id: number,
  post_id: number
): Promise<ActiveStorageType[]> {
  const resp: any = await xhr.get(`/plans/${plan_id}/post_uploader/${post_id}`)

  return resp.data.files
}

export async function deleteFileFromList(
  file: ActiveStorageType,
  plan_id: number,
  post_id: number
): Promise<boolean> {
  const conf = confirm(`Are you sure to delete file ${file.blob.filename}?`)

  if (!conf) return false

  try {
    await xhr.delete(
      `/plans/${plan_id}/post_uploader/${post_id}?file_id=${file.id}`
    )

    return true
  } catch (e: any) {
    toast("There was an error deleting the file", "error")
    return false
  }
}

type extraDataType = {
  plan_id: number
  channel_id: number
  id?: number
  user_id?: number
  create?: string // "true"
}

/**
 *
 * @param file File
 * @param extraData extraDataType
 */
export async function uploadFile(
  file: File,
  extraData: extraDataType
): Promise<ForumPostType> {
  const form = new FormData()
  const { plan_id, channel_id, id, user_id } = extraData
  form.append("forum_post[plan_id]", `${plan_id}`)
  form.append("forum_post[forum_channel_id]", `${channel_id}`)
  form.append("forum_post[file]", file)
  if (id) form.append("forum_post[id]", `${id}`)
  form.append("forum_post[user_id]", `${user_id}`)
  form.append("forum_post[create]", extraData.create || "")

  const { data } = await xhr.post(`/plans/${plan_id}/post_uploader`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  })

  return data
}
